var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 22",
    width: 19,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Home-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #222222 } \r\n\t")), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m3.6 5.9l1.2-1c2.2-2 3.4-2.9 4.7-2.9 1.3 0 2.5 0.9 4.7 2.9l1.2 1c1.3 1.1 1.9 1.6 2.2 2.3 0.4 0.8 0.4 1.6 0.4 3.2v5.1c0 2.3 0 3.5-0.7 4.2-0.7 0.6-1.8 0.7-3.8 0.7v-6.1c0-1.2-1-2.2-2.2-2.2h-3.6c-1.2 0-2.2 1-2.2 2.2v6.1c-2 0-3.1-0.1-3.8-0.7-0.7-0.7-0.7-1.9-0.7-4.2v-5.1c0-1.6 0-2.4 0.4-3.2 0.3-0.7 0.9-1.2 2.2-2.3zm3.9 15.5v-6.1c0-0.1 0.1-0.2 0.2-0.2h3.6c0.1 0 0.2 0.1 0.2 0.2v6.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.26b965e4d0674a2c386cad052b964e2b.svg";
export { ForwardRef as ReactComponent };